import { CardsClubIcon } from './CardsClubIcon';

/**
 * author: Nick
 * id FD5114FD-37CB-4346-BC73-58E1EED49CF3
 * name cards-club
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-club.svg
 * tags
 * - Gaming / RPG 
 */
export const SuitClubsIcon = CardsClubIcon;
export default SuitClubsIcon